import TagManager from "react-gtm-module";

const GTM_ID = "GTM-M72JSZ4D";

export const initTagManager = (mode: string | undefined): void => {
  if (mode !== "prod") return;

  TagManager.initialize({ gtmId: GTM_ID });
};
